'use es6';

let _ = t => t,
  _t;
import styled, { useTheme } from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { applyTheme } from '../theming/actions/themeActions';
import { useDispatch } from 'react-redux';
import { colors } from '../theming/themes/colors';
import { isHalloween } from '../theming/operators/isHalloween';
import { isThemingEnabled } from '../theming/operators/isThemingEnabled';
import { TabletAndBelow } from '../theming/themes/mixins';
import usageTracker from '../lib/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CheckBoxWrapper = styled.div.withConfig({
  displayName: "OptOutThemesToggle__CheckBoxWrapper"
})(["position:relative;"]);
const toggleHeight = '18px';
const toggleWidth = '18px';
const borderRadius = '100px';
const Wrapper = styled.span.withConfig({
  displayName: "OptOutThemesToggle__Wrapper"
})(["position:absolute;left:20px;z-index:100;display:flex;flex-direction:row;bottom:24px;& > span{margin:0 4px;}", ""], TabletAndBelow(_t || (_t = _`
      top: 24px;
  `)));
const CheckBoxLabel = styled.label.withConfig({
  displayName: "OptOutThemesToggle__CheckBoxLabel"
})(["position:absolute;top:0;left:0;width:34px;height:22px;border-radius:100px;background:", ";cursor:pointer;&::after{content:'';display:block;border-radius:", ";width:", ";height:", ";margin:2px;background:", ";box-shadow:1px 3px 3px 1px rgba(0,0,0,0.2);transition:0.2s;}"], colors.SILVER, borderRadius, toggleWidth, toggleHeight, colors.PRIMARYWHITE);
const CheckBox = styled.input.withConfig({
  displayName: "OptOutThemesToggle__CheckBox"
})(["opacity:0;z-index:1;border-radius:15px;width:42px;height:26px;&:checked + ", "{background:", ";&::after{content:'';display:block;border-radius:", ";width:", ";height:", ";margin-left:14px;transition:0.2s;}}"], CheckBoxLabel, colors.PRIMARYORANGE, borderRadius, toggleWidth, toggleHeight);
export const OptOutThemesToggle = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const optOutThemes = () => {
    const selectedTheme = isHalloween(theme) ? 'defaultTheme' : 'halloween';
    usageTracker.log('Theme Changed', {
      theme: selectedTheme
    });
    dispatch(applyTheme(selectedTheme));
  };
  const isSelected = !isHalloween(theme);
  if (!isThemingEnabled()) return null;
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "home.themeToggle"
      })
    }), /*#__PURE__*/_jsxs(CheckBoxWrapper, {
      children: [/*#__PURE__*/_jsx(CheckBox, {
        type: "checkbox",
        id: "optout",
        onChange: () => optOutThemes(),
        checked: isSelected
      }), /*#__PURE__*/_jsx(CheckBoxLabel, {
        htmlFor: "optout"
      })]
    })]
  });
};